import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  cart: null, // Stores the single cart item
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;

      state.cart = item;
    },
    removeFromCart: (state) => {
      state.cart = null;
    },
    clearCart: (state) => {
      state.cart = null;
    },
  },
});

// Export actions to be used in components
export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;

// Single Selector to get the item in the cart
export const selectCartItems = createSelector(
  (state) => state.cart,
  (cart) => ({
    item: cart,
  })
);

// Export the reducer to be included in the store
export default cartSlice.reducer;
